/**
 * Fera Widgets Accessibility
 * Initializes the `fera` object and processes all elements with the class
 * 'fera-productReviewsSummary' to set appropriate ARIA attributes for accessibility.
 *
 * - Hides the child elements of the widget from screen readers.
 * - Sets the `aria-label` attribute on the widget to describe the review score and count.
 */
window.addEventListener('load', function () {
  window.fera = window.fera || {};
  const { fera } = window;
  if (!fera) return;

  const reviewsWidgets = document.querySelectorAll(
    '.fera-productReviewsSummary'
  );
  if (!reviewsWidgets || reviewsWidgets.length === 0) return;

  reviewsWidgets.forEach(widget => {
    const starsElement = widget.querySelector(
      '.fera-productReviewsSummary-stars'
    )?.dataset?.rating;
    const countElement = widget.querySelector(
      '.fera-productReviewsSummary-reviewCount'
    )?.dataset?.value;
    // hide the child elements of the widget from screen readers
    widget
      .querySelector('.fera-productReviewsSummary-content')
      ?.setAttribute('aria-hidden', 'true');
    // add aria label to the widget if a review score and count are available
    if (starsElement > 0 && countElement > 0) {
      widget.ariaLabel = `Rated ${starsElement} out of 5 stars, based on ${countElement} reviews`;
    }
  });
});
